import {
  OrderCancelRestoreParams,
  OrderServeParams,
  OrderFields,
  OrderListParams,
} from "../../view/Modules/Orders/OrderDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const OrderServices = {
  getOrders: (params: OrderListParams) => {
    return AxiosInstance.get(ContentApiRoutes.ORDERS, { params });
  },
  getOrderTotalValue: (params: OrderListParams) => {
    return AxiosInstance.get(ContentApiRoutes.ORDER_TOTAL_VALUE, { params });
  },
  getGroupedOrders: (params: OrderListParams) => {
    return AxiosInstance.get(ContentApiRoutes.GROUPED_ORDERS, { params });
  },
  exportOrders: (params: OrderListParams) => {
    return AxiosInstance.get(ContentApiRoutes.EXPORT_ORDERS, {
      params,
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "orders-export.xls");
      document.body.appendChild(link);
      link.click();
    });
  },
  createOrder: (data: OrderFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_ORDER, data),
  updateOrder: (id: number, data: OrderFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_ORDER.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  cancelRestoreOrder: (id: number, data: OrderCancelRestoreParams) =>
    AxiosInstance.put(
      ContentApiRoutes.CHANGE_ORDER_STATUS.replace(":id", id.toString()),
      data
    ),
  serveOrder: (id: number, data: OrderServeParams) =>
    AxiosInstance.put(
      ContentApiRoutes.CHANGE_ORDER_STATUS.replace(":id", id.toString()),
      data
    ),

  deleteOrder: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_ORDER.replace(":id", id.toString())
    ),

  deleteBulkOrder: (ids: number[]) => {
    let idl = { ids: ids.toString() };
    return AxiosInstance.put(ContentApiRoutes.DELETE_BULK_ORDER, idl);
  },

  assignBulkOrder: (ids: number[], payload: any) => {
    payload.ids = ids.toString();
    return AxiosInstance.put(ContentApiRoutes.ASSIGN_BULK_ORDER, payload);
  },

  viewOrder: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_ORDER.replace(":id", id.toString())
    );
  },
};
